import Decimal from "decimal.js";
import { Address, Hash } from "viem";
import { OrderType } from "../utils/orderTypeUtils";
import { Amount } from "./amount";
import { Chain } from "viem/chains";

export interface TradeHistoryData {
  results: Record<TransactionDetail["txHash"], TransactionDetail>;
  nextAvailableTimestamp: number | null;
}
export type HistoryMetadataByChain = Record<Chain["id"], HistoryMetadata>;
export type HistoryMetadata = Record<
  Hash,
  { decimals: number; icon: string; name: string; symbol: string; displayDecimals: number }
>;

export interface HistoryMetadataRaw {
  results: number;
  timestamp: string;
  tokens: Record<Chain["id"], HistoryMetadata>;
}

export interface TradeHistoryDataRaw {
  results: Array<TransactionDetailRaw>;
  nextAvailableTimestamp: number | null;
  metadata: HistoryMetadataRaw;
}

export enum TRANSACTION_STATUSES {
  "SETTLED" = "SETTLED",
  "REVERTED" = "REVERTED",
}

export interface BoughtOrSoldFields {
  address: Hash;
  amount: Amount;
  amountUsd: Decimal;
}

export interface BoughtOrSoldFieldsRaw {
  contractAddress: Hash;
  amount: bigint;
  amountUsd: Decimal;
  symbol: string;
  decimals: number;
}

export type TokenHistoryInfo = {
  [key: Hash]: BoughtOrSoldFields;
};
export type TokenHistoryInfoResponse = {
  [key: Hash]: BoughtOrSoldFieldsRaw;
};

export interface TransactionDetail {
  chain_id: number;
  status: TRANSACTION_STATUSES;
  type: OrderType;
  sender: Address;
  receiver: Address;
  sellTokens: TokenHistoryInfo;
  buyTokens: TokenHistoryInfo;
  timestamp: Date;
  volumeUsd: Amount;
  gasFeeUsd: number;
  txHash: string;
}

export interface TransactionDetailRaw {
  chain_id: number;
  status: TRANSACTION_STATUSES;
  type: OrderType;
  taker: Address;
  receiver: Address;
  sellTokens: TokenHistoryInfoResponse;
  buyTokens: TokenHistoryInfoResponse;
  timestamp: string;
  volumeUsd: number;
  gasFeeUsd: number;
  txHash: string;
}
